import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/pages/startpage/src/assets/A2.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')